import * as urls from '../apiUrls';
import { doRequest } from 'utils/request';
import { AUCTION_STATUS } from 'globalConstants';
import { AUCTION_LOCATION_ID } from 'components/pledgemanagement/constants';

const postAuctionSearch = (params) => {
  return doRequest(`${urls.SEARCH_AUCTIONS}`, 'post', params);
};

const getAuctionsOver = (params) => {
  return doRequest(`${urls.LOANS_AUCTION}`, 'post', params);
};

const getAuctionsOverFilter = (loanNumber, params) => {
  return doRequest(
    `${urls.LOANS_AUCTION}?loanNumber=${loanNumber}`,
    'post',
    params
  );
};

const getAuctionHouses = () => {
  return doRequest(`${urls.LOANS_AUCTION_HOUSES}`, 'get');
};

const getPfiList = (params) => {
  return doRequest(`${urls.PFI_LIST}`, 'post', params);
};

const getPFILoanSearchItem = (loanNumber, params) => {
  return doRequest(`${urls.PFI_LOAN_SEARCH}/${loanNumber}`, 'post', params);
};

const getPFIPurchaseSearchItem = (purchaseNumber, params) => {
  return doRequest(
    `${urls.PFI_PURCHASE_SEARCH}/${purchaseNumber}`,
    'post',
    params
  );
};

const putConfirmCollection = (auctionId) => {
  return doRequest(`${urls.CONFIRM_COLLECTION}/${auctionId}`, 'put');
};

const getAuctionDetails = (id, auctionStatus, bagNumber, params) => {
  if (auctionStatus === AUCTION_STATUS.CLOSED) {
    if (id) {
      return doRequest(`${urls.CLOSED_AUCTION_LOAN_DETAILS}/${id}`, 'get');
    } else {
      return doRequest(`${urls.CLOSED_AUCTION_LOAN}`, 'post', params);
    }
  } else if (auctionStatus === AUCTION_STATUS.PENDING_RETURN) {
    return doRequest(`${urls.PENDING_RETURN_AUCTION_LOAN}/${id}`, 'get');
  } else if (
    auctionStatus === AUCTION_STATUS.LIVE_STORE ||
    auctionStatus === AUCTION_STATUS.LIVE_AUCTION
  ) {
    return doRequest(
      `${urls.AUCTION_CHAPTER_LOANS}/${id}/${AUCTION_LOCATION_ID}/${bagNumber}`,
      'get'
    );
  }
};

const getConfirmAuctionSettlement = (auctionId) => {
  return doRequest(`${urls.CONFIRM_AUCTION_SETTLEMENT}/${auctionId}`, 'get');
};

const putSettleAuction = (auctionId) => {
  return doRequest(`${urls.SETTLE_AUCTION}/${auctionId}`, 'put');
};

const putUpdateSoldValue = (params) => {
  return doRequest(`${urls.UPDATE_SOLD_VALUE}`, 'put', params);
};

const putPassAuctionLot = (
  auctionId,
  pledgeNumber,
  hasPassNoPayRights,
  params
) => {
  return doRequest(
    `${
      hasPassNoPayRights ? urls.SST_PASS_AUCTION_LOT : urls.PASS_AUCTION_LOT
    }/${auctionId}/${pledgeNumber}`,
    'post',
    params
  );
};

const getPrintPassList = (auctionId, printfor, printtype) => {
  return doRequest(
    `${urls.PRINT_AUCTION}/${auctionId}/${printfor}/${printtype}`,
    'get'
  );
};

const getLoanDetails = (loanNumber, auctionDate) => {
  if (auctionDate) {
    // PFA
    return doRequest(
      `${urls.GET_LOAN_DETAILS}/${loanNumber}/${auctionDate}`,
      'get'
    );
  } else
    return doRequest(
      // PFI
      `${urls.GET_LOAN_DETAILS}/${loanNumber}`,
      'get'
    );
};

const getAuctionOpenBags = (auctionId) => {
  return doRequest(`${urls.GET_AUCTION_BAG_SUMMARIES}/${auctionId}`, 'get');
};

const addPledgeToAuctionBag = (auctionId, params) => {
  return doRequest(`${urls.AUCTION_BAG}/${auctionId}`, 'post', params);
};

const createAuctionCourierBag = (auctionId, params) => {
  return doRequest(`${urls.AUCTION_BAG}/${auctionId}`, 'post', params);
};
const getPurchaseLoanDetails = (loanNumber) => {
  return doRequest(`${urls.GET_PURCHASE_LOAN_DETAILS}/${loanNumber}`, 'get');
};
const getParentItemCategory = (Id) => {
  return doRequest(`${urls.GET_PARENT_ITEM_CATEGORY}/${Id}`, 'get');
};
const postReviewItemsPfa = (params) => {
  return doRequest(`${urls.REVIEW_ITEMS_PFA_PFI}`, 'post', params);
};

const postPfiImageCheck = (params) => {
  return doRequest(`${urls.PFI_IMAGE_CHECK}`, 'post', params);
};

const postPledgeToPfi = (params) => {
  return doRequest(`${urls.PUSH_PLEDGE_TO_PFI}`, 'post', params);
};
const postPurchaseToPfi = (params) => {
  return doRequest(`${urls.PUSH_PURCHASE_TO_PFI}`, 'post', params);
};

const getItemPfiBarcodes = (barCodeParams) => {
  return doRequest(`${urls.POST_PFI_BARCODE}`, 'post', barCodeParams);
};
const putLockAuction = (auctionId) => {
  return doRequest(`${urls.LOCK_AUCTION}/${auctionId}`, 'put');
};

const getNotifyAuctionLocking = (auctionId) => {
  return doRequest(`${urls.NOTIFY_AUCTION_LOCKING}`, 'get');
};

const getPledgeItemsDetails = (itemId) => {
  return doRequest(`${urls.ITEMS_REVIEW_LIST}/${itemId}`, 'get');
};

const putMoveToAuction = (params) => {
  return doRequest(`${urls.MOVE_TO_AUCTION}`, 'put', params);
};

const getGenerateLotSticker = (loanNumber, loanId, originalLoanId) => {
  return doRequest(
    `${urls.GENERATE_LOT_STICKER}/${loanNumber}/${loanId}/${originalLoanId}`,
    'get',
    null,
    'application/json',
    false,
    'arraybuffer'
  );
};

const postConfiscatePledges = (params) => {
  return doRequest(`${urls.POST_CONFISCATE_PLEDGES}`, 'post', params);
};

const postVulnerablePledges = (params) => {
  return doRequest(`${urls.POST_VULNERABLE_PLEDGES}`, 'post', params);
};

const getVulnerablePledges = () => {
  return doRequest(`${urls.GET_VULNERABLE_PLEDGES}`, 'get');
};
const getConfiscationNotesByLoanId = (loanId) => {
  return doRequest(`${urls.GET_CONFISCATION_NOTES_BY_LOAID}/${loanId}`, 'get');
};

const addConfiscationNotes = (params) => {
  return doRequest(`${urls.GET_CONFISCATION_NOTES_BY_LOAID}`, 'post', params);
};

const getConfiscationLoans = () => {
  return doRequest(`${urls.GET_CONFISCATION_LOANS}`, 'get');
};

const printNPAStatement = () => {
  return doRequest(
    `${urls.PRINT_NPA_STATEMENT}`,
    'get',
    '',
    'application/json',
    false,
    'arraybuffer'
  );
};

const releaseConfiscation = (params) => {
  return doRequest(`${urls.RELEASE_CONFISCATION}`, 'post', params);
};

const getVulnerableNotes = (loanId) => {
  return doRequest(`${urls.GET_VULNERABLE_NOTES}/${loanId}`, 'get');
};

const postVulnerableNote = (params) => {
  return doRequest(`${urls.POST_VULNERABLE_NOTE}`, 'post', params);
};

const postRemoveVulnerableNote = (params) => {
  return doRequest(`${urls.POST_RELEASE_VULNERABLE}`, 'post', params);
};

const getCourierCompanies = () => {
  return doRequest(`${urls.GET_COURIER_COMPANIES}`, 'get');
};

const getPledgeBagDetails = (auctionId, loanNumber) => {
  return doRequest(
    `${urls.GET_PLEDGE_BAG_INFO}/${auctionId}/${loanNumber}`,
    'get'
  );
};

const getAuctionBagPledges = (auctionId, categoryId, categoryType) => {
  return doRequest(
    `${urls.GET_AUCTION_BAG_PLEDGES_BY_BAG}/${auctionId}/${categoryId}/${categoryType}`,
    'get'
  );
};

const getUnsentLetterAuctionBagPledges = (
  auctionId,
  categoryId,
  categoryType
) => {
  return doRequest(
    `${urls.GET_UNSENT_LETTER_AUCTION_BAG_PLEDGES_BY_BAG}/${auctionId}/${categoryId}/${categoryType}`,
    'get'
  );
};

const postAuctionLoanPnp = (params) => {
  return doRequest(`${urls.AUCTION_LOAN_PNP}`, 'post', params);
};

const putMovePledge = (params, auctionId) => {
  return doRequest(`${urls.PUT_MOVE_PLEDGE}/${auctionId}`, 'put', params);
};

const getItemImages = (id) => {
  return doRequest(`${urls.GET_ITEM_ALL_IMAGES}/${id}`, 'get');
};

const getAuctionBagsAll = (
  auctionId,
  courierCompanyId,
  categoryId,
  categoryType,
  forceAll
) => {
  return doRequest(
    `${urls.GET_AUCTION_BAGS_ALL}/${auctionId}/${courierCompanyId}/${categoryId}/${categoryType}/${forceAll}`,
    'get'
  );
};

const postAuthoriseSealBag = (params, authorizationHeaders) => {
  return doRequest(
    `${urls.POST_AUTHORIZE_SEAL_BAG}`,
    'get',
    params,
    '',
    false,
    '',
    authorizationHeaders
  );
};

const deleteAuctionBag = (bagNumber, forceDelete) => {
  return doRequest(`${urls.AUCTION_BAG}/${bagNumber}/${forceDelete}`, 'delete');
};

const putSealAuctionBag = (details) => {
  return doRequest(`${urls.PUT_SEAL_BAG}`, 'put', details);
};

const putScanAuctionBag = (auctionId, bagNumber) => {
  return doRequest(`${urls.PUT_SCAN_BAG}/${auctionId}/${bagNumber}`, 'put');
};

const deletePledgeFromAuction = () => {
  return doRequest(`${urls.CLEAR_AUCTION_PLEDGE}`, 'delete');
};

const searchAuctionLoan = (loanNumber) => {
  return doRequest(`${urls.SEARCH_AUCTION_AGREEMENT}/${loanNumber}`, 'get');
};

const getAuctionEnabledStores = () => {
  return doRequest(`${urls.GET_AUCTION_ENABLED_STORES}`, 'get');
};

const getAuctionLiveAtStore = () => {
  return doRequest(`${urls.GET_AUCTION_LIVE_AT_STORE}`, 'get');
};

const printPfiListReport = (params) => {
  return doRequest(
    `${urls.GET_PFI_LIST_PRINT}`,
    'POST',
    params,
    'application/json',
    false,
    'arraybuffer'
  );
};

const printPFAList = (params) => {
  return doRequest(
    `${urls.PRINT_PFA_LIST}`,
    'POST',
    params,
    'application/json',
    false,
    'arraybuffer'
  );
};

const postAuctionLoanStatus = (params) => {
  return doRequest(`${urls.POST_AUCTION_LOAN_STATUS}`, 'post', params);
};

const getPassedLoans = (auctionId, bagId) => {
  return doRequest(
    `${urls.GET_PASSED_LOANS}/${auctionId}/bag/${bagId}/passed-loans`,
    'get'
  );
};

// Police Hold

const getPoliceHoldList = () => {
  return doRequest(`${urls.GET_POLICE_HOLD_LIST}`, 'get');
};

const postConfiscateItems = (params) => {
  return doRequest(`${urls.POST_POLICE_HOLD_ITEMS}`, 'post', params);
};

const getItemsPoliceHoldNotes = (loanId) => {
  return doRequest(`${urls.GET_ITEMS_POLICE_HOLD_NOTES}/${loanId}`, 'get');
};

const addItemsPoliceHoldNotes = (params) => {
  return doRequest(`${urls.GET_ITEMS_POLICE_HOLD_NOTES}`, 'post', params);
};

const releaseConfiscatedItems = (params) => {
  return doRequest(`${urls.RELEASE_CONFISCATED_ITEMS}`, 'post', params);
};

export {
  postAuctionSearch,
  getAuctionsOver,
  getAuctionsOverFilter,
  getAuctionHouses,
  getAuctionDetails,
  getPfiList,
  getPFILoanSearchItem,
  getPFIPurchaseSearchItem,
  putConfirmCollection,
  getConfirmAuctionSettlement,
  putSettleAuction,
  putUpdateSoldValue,
  getPrintPassList,
  getLoanDetails,
  getAuctionOpenBags,
  addPledgeToAuctionBag,
  createAuctionCourierBag,
  getPurchaseLoanDetails,
  getParentItemCategory,
  putPassAuctionLot,
  putLockAuction,
  getNotifyAuctionLocking,
  getItemPfiBarcodes,
  postPledgeToPfi,
  postPurchaseToPfi,
  getPledgeItemsDetails,
  postReviewItemsPfa,
  putMoveToAuction,
  getGenerateLotSticker,
  postConfiscatePledges,
  postVulnerablePledges,
  getVulnerablePledges,
  getConfiscationNotesByLoanId,
  addConfiscationNotes,
  getConfiscationLoans,
  printNPAStatement,
  releaseConfiscation,
  getVulnerableNotes,
  postVulnerableNote,
  postRemoveVulnerableNote,
  getCourierCompanies,
  getPledgeBagDetails,
  getAuctionBagPledges,
  putMovePledge,
  getItemImages,
  getAuctionBagsAll,
  postAuthoriseSealBag,
  deleteAuctionBag,
  putSealAuctionBag,
  putScanAuctionBag,
  deletePledgeFromAuction,
  searchAuctionLoan,
  getAuctionEnabledStores,
  getAuctionLiveAtStore,
  postPfiImageCheck,
  printPFAList,
  printPfiListReport,
  postAuctionLoanStatus,
  getPassedLoans,
  getPoliceHoldList,
  postConfiscateItems,
  getItemsPoliceHoldNotes,
  addItemsPoliceHoldNotes,
  releaseConfiscatedItems,
  getUnsentLetterAuctionBagPledges,
  postAuctionLoanPnp,
};
